module.exports = __webpack_public_path__ + "fonts/OpenSans800.30996709.woff";